<template>
  <nav>
    <ul class="hover-shadow-lg">
      <li v-for="(navItem, index) in navItems" :key="navItem.title" @click="navigation">
        <router-link
          :to="navLink(navItem)"
          :class="[
            'flex gap-2 p-4 border-x border-y group relative',
            {
              'rounded-t-lg': index === 0,
              'rounded-b-lg': index === navItems.length - 1,
              'bg-blue-50 border-blue-400 text-blue-700': isActive(navItem),
              'text-neutral-500 hover:bg-blue-50': !isActive(navItem),
            },
          ]"
        >

          <Icon
            :icon="navItem.icon"
            height="25"
            class="mt-0.5 flex-shrink-0"
            :class="[{ 'text-blue-600': isActive(navItem) }]"
          />
          <div class="flex flex-col gap-1">
            <span
              class="text-xl text-medium"
              :class="[isActive(navItem) ? 'text-blue-800' : 'text-neutral-700']"
            >
              {{ navItem.title }}
            </span>
            <span
              class="text-sm leading-none"
              :class="[isActive(navItem) ? 'text-blue-600' : 'text-neutral-500']"
            >
              {{ navItem.description }}
            </span>
          </div>
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import { Icon } from "@iconify/vue2";

export default {
  name: "CourseDetailNavigation",
  components: {
    Icon,
  },
  computed: {
    course() {
      return this.$store.state.course.current;
    },
    olympic() {
      return this.$store.state.course.olympic;
    },
    courseId() {
      return this.$route.params.id;
    },
    navItems() {
      const base = `/course/${this.courseId}`;
      const items = [
        {
          icon: "octicon:bookmark-24",
          title: "Introducción",
          description: "Aquí encontrarás un resumen de lo que trata el curso",
          link: `${base}/introduction`,
        },
      ];
      if (this.olympic) {
        items.push({
          icon: "ph:trophy",
          title: "Fases de la olimpiada",
          description: "Exámenes y avance por fase de la competencia",
          link: `${base}/phases`,
          slug: this.olympic.slug,
        });
      }
      items.push(
        {
          icon: "ph:book-open-text",
          title: "Lecciones",
          description: "Conoce los conceptos necesarios para dominar este tema",
          link: `${base}/lessons`,
        },
        {
          icon: "octicon:bookmark-24",
          title: "Práctica",
          description: "Repasa los conocimientos adquiridos hasta ahora",
          link: `${base}/practices`,
        }
      );
      if (!this.olympic) {
        items.push(
          {
            icon: "fluent:options-48-regular",
            title: "Simulacros",
            description: "Preparate para los examenes del curso",
            link: `${base}/simulacrums`,
          },
          {
            icon: "ph:shield-check",
            title: "Exámenes",
            description: "Demuestra lo que haz aprendido en el curso",
            link: `${base}/exams`,
          }
        );
      }
      items.push({
        icon: "ph:chart-bar",
        title: "Tu desempeño",
        description: "Resumen visual de tu exactitud, intentos y progreso dentro de este curso.",
        link: `${base}/performance`,
      });
      return items;
    },
  },
  methods: {
    navLink(navItem) {
      if (navItem.slug) {
        return { path: navItem.link, query: { slug: navItem.slug } };
      }
      return navItem.link;
    },
    isActive(navItem) {
      const currentPath = this.$route.path;
      return currentPath === navItem.link || currentPath.startsWith(`${navItem.link}/`);
    },
    navigation() {
      this.$emit("navigation");
    },
  },
};
</script>
